import React from "react";
import DemoButton from "../Demo/DemoButton";
import CustomButton from "../Buttons/CustomButton";
import Link from "next/link";
import Image from "next/image";
import slider1 from "@/Helper/images/slider/healthcare/slider1.png";

const Healthcare = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">
          Restaurants can easily engage customers with AI{" "}
        </p>
        <p className="subheading">
          Hospitality industries get the opportunity to improve their customer
          services. It improves hotel operations by automating repetitive tasks.
        </p>
        <div className="btn_container">
          <DemoButton PrimaryColorBtn />
          <Link href={"/hospitality"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Digital signage software driving steadfast results"
            width={459}
            height={253}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default Healthcare;
